import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import * as React from 'react';

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 18,
  height: 18,
  border: `2px solid ${theme.palette.text.primary}`,
  'input:disabled ~ &': {
    boxShadow: 'none',
    borderColor: theme.palette.text.disabled
  },
  'input:checked:disabled ~ &': {
    backgroundColor: theme.palette.text.secondary,
    borderColor: theme.palette.text.secondary
  }
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#222',
  '&:before': {
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""'
  }
});

const CustomCheckbox = (props: CheckboxProps) => {
  return <Checkbox disableRipple checkedIcon={<BpCheckedIcon />} icon={<BpIcon />} {...props} />;
};

export default CustomCheckbox;
